import WorkHttp from '@/http/WorkHttp';

export interface CashRegister {
  id?: number
  title?: string,
  receiver?: string,
  description?: string,
  balance?: number,
  default?: boolean,
  owner_cash?: boolean,
  enterprise_id: number,
  created_at?:string,
  updated_at?:string
}

export class CashRegisterModel implements CashRegister {
  id?: number;
  title?: string;
  receiver?: string;
  description?: string;
  balance?: number;
  default?: boolean;
  owner_cash?: boolean;
  created_at?:string;
  updated_at?:string;
  enterprise_id: number;

  constructor (data: CashRegister) {
    this.enterprise_id = data.enterprise_id;
    Object.assign(this, data);
  }

  public addBalance (sum:number, comment:string) {
    return new Promise((resolve, reject) => {
      if (this.id) {
        (new WorkHttp(this.enterprise_id)).post({ url: 'cash_registers/add-balance',
          data: {
            cash_register_id: this.id,
            value: sum,
            comment: comment
          } }).then(r => { resolve(r); }).catch(e => { reject(e); });
      } else {
        reject(Error);
      }
    });
  }

  public historyRequest () {
    return new Promise((resolve, reject) => {
      if (this.id) {
        (new WorkHttp(this.enterprise_id)).request({ url: `cash_registers/${this.id}` })
          .then(r => { resolve(r); }).catch(e => { reject(e); });
      } else {
        reject(Error);
      }
    });
  }
}
